import { Fragment, useContext } from 'react';
import styled from 'styled-components';

const StyledSeparator = styled.p`
	align-items: center;
	display: flex;
	justify-content: center;
	margin-bottom: 1rem;
	min-height: 1rem;

	&:before,
	&:after {
		background-color: #000;
		content: '';
		flex-grow: 1;
		height: 1px;
	}
`;

export default function Separator({ label }) {
	return (
		<StyledSeparator className="container slp-Section slp-Separator">
			{label && label.length && (
				<Fragment>
					&nbsp;
					{label}
					&nbsp;
				</Fragment>
			)}
		</StyledSeparator>
	);
}
